import { Modal, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { Button, TypographyPageTitle } from '@seen/ui'
import { IconPlus } from '@tabler/icons-react'
import { useQueryClient } from '@tanstack/react-query'
import type { JSX } from 'react'
import { CreateSDR } from '#src/components/sdr/create/CreateSDR.tsx'
import { SDRTable } from '#src/components/sdr/display/SDRTable.tsx'
import { useCurrentParticipant } from '#src/contexts/current-participant/useCurrentParticipant.ts'
import { cacheKeys } from '#src/hooks/cacheKeys.ts'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

export const SDRsPatientPage = (): JSX.Element => {
  const participant = useCurrentParticipant()
  const queryClient = useQueryClient()
  const isReadOnly = useIsReadOnly()

  const [showCreateModal, { open: openCreateModal, close: closeCreateModal }] =
    useDisclosure(false)

  return (
    <div className="grid gap-6">
      <div className="flex items-center justify-between gap-4">
        <TypographyPageTitle>SDRs</TypographyPageTitle>
        {!isReadOnly && (
          <Button
            variant="outline"
            onClick={openCreateModal}
            className="flex items-center gap-2"
          >
            <IconPlus size={16} />
            Create SDR
          </Button>
        )}
      </div>
      <SDRTable patientRef={participant.reference} />
      {!isReadOnly && (
        <Modal
          opened={showCreateModal}
          onClose={closeCreateModal}
          closeOnEscape={false}
          title={<Text className="font-medium">Create new SDR</Text>}
          size="xl"
        >
          <Modal.Body p={0}>
            <CreateSDR
              patient={participant.toFhirResource()}
              onCreate={() => {
                closeCreateModal()
                cacheKeys.invalidateMutation(queryClient, 'Task', 'search')
              }}
              onCancel={closeCreateModal}
            />
          </Modal.Body>
        </Modal>
      )}
    </div>
  )
}
